<template>
  <footer>
    <v-row justify="center">
      <v-col class="col-lg-8 col-md-9 col-sm-10">
        <div class="footer-logo">
          <a href="http://rufftuff.com"><img src="https://seats.rufftuff.com/images/rt-logo.svg" class="footer-logo"></a>
        </div>
        <address>
          2252 South Presidents Drive, Suite E<br>West Valley City, UT 84120 USA
        </address>
        <div class="footer-contact">
          <a href="tel:801-972-5845"><i class="fas fa-phone"></i> 801-972-5845</a>
          <a href="mailto:customerservice@rufftuff.com"><i class="fas fa-envelope"></i> customerservice@rufftuff.com</a> 
        </div>
        <p>
          <a href="https://www.rufftuff.com/privacy-policy" target="_blank">Privacy Policy</a> <span class="pipe"> | </span>
          <a href="https://www.rufftuff.com/warranty-and-returns" target="_blank">Warranty &amp; Return Policy</a>
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col style="text-align: center;">
        <img src="https://seats.rufftuff.com/images/seal.jpg" class="mobile-seal">
      </v-col>
    </v-row>
  </footer>
</template>
<script>

  export default{
    name: 'Footer'
  }

</script>
<style lang="scss">
footer {
  background-color: #333332;
  padding: 30px 0;

  .footer-logo {
    text-align: center;

    img {
      width: 180px;
    }
  }

  .footer-contact {
    text-align: center;
    margin-top: 16px;

    a {
      color: $white;
      text-decoration: none;
      font-weight: 600;
      display: block;

      @media screen and (min-width: 600px) {
        display: inline-block;
      }

      &:first-child {
        padding-right: 15px;
      }
    }
  }

  p {
    color: $white !important;
    text-align: center;
    margin-top: 16px;

    a {
      color: $white !important;
      text-decoration: none;
      display: block;

      @media screen and (min-width: 600px) {
        display: inline-block;
      }
    }
  }

  address {
    text-align: center;
    color: $white;
    font-size: 14px;
    font-style: normal;
  }
}
</style>
